import { Mail, MessageCircle } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { Property } from "@/schemas/property";
import { Smartphone } from "lucide-react";

type ContactButtonProps = {
  property: Property;
  type: "email" | "message" | "call";
  disabled: boolean;
  message: string;
};

export default function ContactButton({
  property,
  type,
  disabled,
  message,
}: ContactButtonProps) {
  const onClick = () => {
    if (type === "message") {
      const phoneNumber = property.listing_agent_phone?.replace(/\D/g, "");
      window.location.href = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
    }
    if (type === "email") {
      const subject = `Tour Request: ${property.address}`;
      window.location.href = `mailto:${
        property.listing_agent_email
      }?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
        message,
      )}`;
    }
    if (type === "call") {
      const phoneNumber = property.listing_agent_phone?.replace(/\D/g, "");
      window.location.href = `tel:${phoneNumber}`;
    }
  };

  return (
    <Button
      className="w-full gap-2 disabled:opacity-50"
      size="lg"
      variant="outline"
      disabled={type !== "call" ? disabled : false}
      onClick={onClick}
    >
      {type === "call" ? (
        <Smartphone className="h-4 w-4" />
      ) : type === "email" ? (
        <Mail className="h-4 w-4" />
      ) : (
        <MessageCircle className="h-4 w-4" />
      )}
      {type === "message" ? "Message" : type === "email" ? "Email" : "Call"}
    </Button>
  );
}
